
const Mutations = {

    // Member
    setMemberProfile (state, data) {
        state.member = data;
    },
    // Project
    setProject (state, data) {
        state.projects.unshift(data);
    },
    updateProjectUrl (state, data) {
        let project = state.projects.find(x => x.projectId === data.projectId);
        project.url = data.url;
        project.updateDate = data.updateDate;
        for(let program of project.programs){
            let p = data.programs.find(x => x.programId === program.programId);
            program.url = p.url;
            program.updateDate = p.updateDate;
        }
    },



    // Program
    setProgram (state, data) {
        state.projects
            .find(x => x.projectId === data.projectId)
            .programs
            .unshift(data);
    },


    // Study
    setStudy (state, data) {
        state.projects
            .find(x => x.programs.find(y => y.programId === data.programId))
            .programs.find(y => y.programId === data.programId)
            .studies
            .unshift(data);
    },
    setSaveState (state, isSaving) {
        state.isSavingStudy = isSaving;
    },



    // Forecast
    runStudy (state, data) {

    },
    setProgramForecastVersionId (state,data) {

        var programId = data.parentId;
        var forecastVersionId = data.forecastVersionId;
        var program = null;
        //debugger;
        for (var i=0; i < state.projects.length;i++)
        {
            program = state.projects[i].programs.find(y => y.programId === programId);
            
            if (program!==null && program !== undefined)
                break;
        }
        
        if (program === null || program === undefined)
            return;
        
        let uncompletedVersion = program.forecastVersions.find(y=> y.processStatus === 1 && (y.forecastVersionId === undefined || y.forecastVersionId === null));
        //debugger;
        if (uncompletedVersion!=null)
            uncompletedVersion.forecastVersionId = forecastVersionId;
    },
    setForecastVersion (state, data) {
        state.projects.forEach((project) =>{

            const programVersion = project.programs.find(y => y.programId === data.parentId);
            if(programVersion != null)
            {
                programVersion.forecastVersions.unshift(data);
                return;
            }

            project.programs.forEach((program) =>{
                const studyVersion = program.studies.find(y => y.studyId === data.parentId);
                if(studyVersion != null)
                {
                    studyVersion.forecastVersions.unshift(data);
                    return;
                }
            });
        });
    },
    setOldForecastVersion (state, data) {
        state.projects.forEach((project) =>{

            const programVersion = project.programs.find(y => y.programId === data.parentId);
            if(programVersion != null)
            {
                const version = programVersion.forecastVersions.find(y => y.forecastVersionId === data.forecastVersionId);
                version.data = data.data;
                return;
            }

            for(let program of project.programs){

                const study = program.studies.find(y => y.studyId === data.parentId);
                if(!study)
                    continue;

                const version = study.forecastVersions.find(y => y.forecastVersionId === data.forecastVersionId);
                version.data = data.data;
            }
        });
    },



    // DataView
    setDataViewForecast (state, study) {
        state.dataView.forecast = study;
    },
};

export default Mutations
